import { makeGetRequest } from 'owa-ows-gateway';
import { SubscriberType } from '../contracts/subscriberType';

const getSubscriberTypeUrl: string = 'ows/api/beta/PremiumUser/subscriberType';

export async function getSubscriberType(): Promise<SubscriberType> {
    let response = await makeGetRequest(getSubscriberTypeUrl);
    return response;
}
